<template>
  <div style="background: #fff;">
    <div class="section" style="min-width: 1200px;">
      <span class="title">{{ $t('SeaExport.PortOfDestinationCustomsData') }}</span>
      <div>
        <div class="customs-data-container">
          <div v-for="(item, index) in customsDataList" :key="item.uuid || index" class="customs-data-row">
            <div class="row-header">
              <span class="row-title">{{ $t('SeaExport.ProductName') }}{{ index + 1 }}</span>
              <el-button
                v-if="!readonly"
                type="text"
                style="color: #F56C6C;"
                @click="deleteItem(index)"
              >{{ $t('SeaExport.DeleteThisProduct') }}</el-button>
            </div>
            <el-divider />
            <!-- 委托信息区域 -->
            <div class="customs-section">
              <span class="section-title">{{ $t('SeaExport.ConsignInfo') }}</span>
              <el-form :disabled="readonly || consignReadonly" label-width="100px" label-position="left">
                <el-form-item :label="$t('SeaExport.HsCode')">
                  <el-input
                    v-model="item.hsCode"
                    :disabled="readonly || consignReadonly"
                    type="textarea"
                    :rows="2"
                    style="max-width:300px"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ChineseName')">
                  <el-input
                    v-model="item.chineseName"
                    :disabled="readonly || consignReadonly"
                    type="textarea"
                    :rows="2"
                    style="max-width:300px"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.EnglishName')">
                  <el-input
                    v-model="item.englishName"
                    :disabled="readonly || consignReadonly"
                    type="textarea"
                    :rows="2"
                    style="max-width:300px"
                  />
                </el-form-item>
                <el-form-item>
                  <template slot="label">
                    <span style="color: #F56C6C;">*</span> {{ $t('SeaExport.DeclaredValue') }}
                  </template>
                  <div style="display: flex;">
                    <el-input-number
                      v-model="item.declaredValue"
                      :disabled="readonly || consignReadonly"
                      :min="0"
                      :precision="2"
                      controls-position="right"
                      style="max-width:300px"
                      @change="calculateEstimatedTariff(index)"
                    />
                    <el-select
                      v-model="item.currency"
                      :disabled="readonly || consignReadonly"
                      filterable
                      placeholder="币种"
                      style="width:90px;margin-left:5px"
                    >
                      <el-option
                        v-for="currency in currencyList"
                        :key="currency.uuid"
                        :label="currency.code"
                        :value="currency.code"
                      />
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.TariffRate')">
                  <el-input-number
                    v-model="item.tariffRate"
                    :disabled="readonly || consignReadonly"
                    :min="0"
                    :precision="2"
                    controls-position="right"
                    style="flex: 1;max-width:300px"
                    @change="calculateEstimatedTariff(index)"
                  />
                  <span style="margin-left:5px">%</span>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.EstimatedTariff')">
                  <div style="display: flex;align-items: center;">
                    <el-input
                      :value="item.estimatedTariff || 0"
                      disabled
                      style="width:60px"
                    />
                    <span style="margin-left:5px">{{ item.currency || 'USD' }}</span>
                    <span class="estimated-tariff-tip" style="margin-left:10px;background:#FDF6EC;padding:2px 8px;border-radius:3px;font-size:12px;color:#E6A23C;">仅预估参考，实际以海关账单为准</span>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <el-divider />
            <!-- 清关信息区域 -->
            <div class="customs-section">
              <div class="section-title-row">
                <span class="section-title">{{ $t('SeaExport.DestPortCustomsClearanceInfo') }}</span>
                <el-button
                  v-if="showCopyConsignBtn && !customsSectionReadonly"
                  icon="el-icon-document-copy"
                  class="copy-consign-btn"
                  @click="copyConsignToCustoms(index)"
                >复制委托信息</el-button>
              </div>
              <el-form :disabled="readonly || customsSectionReadonly" label-width="100px" label-position="left">
                <el-form-item :label="$t('SeaExport.HsCode')">
                  <el-input
                    v-model="item.customsHsCode"
                    :disabled="readonly || customsSectionReadonly"
                    placeholder="请输入清关HS编码"
                    style="max-width:300px"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ChineseName')">
                  <el-input
                    v-model="item.customsChineseName"
                    :disabled="readonly || customsSectionReadonly"
                    placeholder="请输入清关中文品名"
                    style="max-width:300px"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.EnglishName')">
                  <el-input
                    v-model="item.customsEnglishName"
                    :disabled="readonly || customsSectionReadonly"
                    placeholder="请输入清关英文品名"
                    style="max-width:300px"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.CustomsValue')">
                  <div style="display: flex;">
                    <el-input-number
                      v-model="item.customsValue"
                      :disabled="readonly || customsSectionReadonly"
                      :min="0"
                      :precision="2"
                      controls-position="right"
                      style="max-width:300px"
                      @change="calculateCustomsTariff(index)"
                    />
                    <el-select
                      v-model="item.customsValueCurrency"
                      :disabled="readonly || customsSectionReadonly"
                      filterable
                      placeholder="币种"
                      style="width:90px;margin-left:5px"
                    >
                      <el-option
                        v-for="currency in currencyList"
                        :key="currency.uuid"
                        :label="currency.code"
                        :value="currency.code"
                      />
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.CustomsTariff')">
                  <div style="display: flex;">
                    <el-input-number
                      v-model="item.customsTariff"
                      disabled
                      :min="0"
                      :precision="2"
                      controls-position="right"
                      style="max-width:300px"
                    />
                    <span style="margin-left:5px">{{ item.customsValueCurrency || 'USD' }}</span>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.TariffRate')">
                  <el-input-number
                    v-model="item.customsTariffRate"
                    :disabled="readonly || customsSectionReadonly"
                    :min="0"
                    :precision="2"
                    controls-position="right"
                    style="flex: 1;max-width:300px"
                    @change="calculateCustomsTariff(index)"
                  />
                  <span style="margin-left:5px">%</span>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.CustomsBroker')">
                  <el-select
                    v-model="item.customsBrokerCmpIdx"
                    :disabled="readonly || customsSectionReadonly"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请选择清关行"
                    style="max-width:300px;width:300px"
                    :remote-method="searchCustomsBroker"
                    @change="onCustomsBrokerChange(item)"
                  >
                    <el-option
                      v-for="broker in brokerOptions"
                      :key="broker.cmpIdx"
                      :label="broker.chineseName || broker.englishName"
                      :value="String(broker.cmpIdx)"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Bond')">
                  <el-select
                    v-model="item.bond"
                    :disabled="readonly || customsSectionReadonly"
                    filterable
                    placeholder="请选择Bond编号"
                    style="max-width:300px;width:300px"
                    @change="onBondChange(item)"
                  >
                    <el-option
                      v-for="bond in bondList"
                      :key="bond.uuid"
                      :label="bond.bondNo"
                      :value="bond.bondNo"
                    />
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- 新增多品名区域按钮 -->
          <div v-if="!readonly" class="add-row-area">
            <el-button type="primary" icon="plus" @click="addRow">{{ $t('SeaExport.AddMultipleProductArea') }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getNoPaginationCurrencyList } from '@/api/basicData/currency'
import { getCompanyListByType4Cache } from '@/api/company'
import { getBondByCustomsBrokerId, getEffectiveAndWarningBonds } from '@/api/bondManagement'

export default {
  name: 'TabDestinationCustomsData',
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    isSalesForSzfs: { type: Boolean, default: false },
    forceReadonly: { type: Boolean, default: false },
    consignReadonly: { type: Boolean, default: false },
    customsSectionReadonly: { type: Boolean, default: true },
    showCopyConsignBtn: { type: Boolean, default: false }
  },
  data() {
    return {
      TYPE_NAMES,
      customsDataList: [],
      selectedRow: null,
      currencyList: [],
      jobData: {},
      originalDataList: [],
      customsBrokerList: [],
      customsBrokerSearchTimer: null,
      bondList: []
    }
  },
  computed: {
    readonly() {
      return this.forceReadonly || this.action === 'look'
    },
    // 合并清关行选项：原始列表 + 数据中已选但列表缺失的项，确保回显不污染原始列表
    brokerOptions() {
      const options = [...this.customsBrokerList]
      this.customsDataList.forEach(item => {
        if (item.customsBrokerCmpIdx && item.customsBroker) {
          if (!options.find(b => String(b.cmpIdx) === String(item.customsBrokerCmpIdx))) {
            options.push({ cmpIdx: item.customsBrokerCmpIdx, chineseName: item.customsBroker, englishName: item.customsBroker })
          }
        }
      })
      return options
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) return
      this.jobData = row || {}
      this.customsDataList = []
      await Promise.all([
        this.loadCurrencyList(),
        this.loadCustomsBrokerList(),
        this.loadBondList()
      ])
      const list = row && row.destPortCustomsDataList
      if (list && list.length > 0) {
        // 获取第一个币种作为默认值
        const firstCurrency = (this.currencyList.length > 0) ? this.currencyList[0].code : 'USD'
        // 先处理数据再赋值，确保 Vue 2 能正确追踪所有属性（包括 customsValueCurrency 等前端新增字段）
        const parsedList = JSON.parse(JSON.stringify(list))
        parsedList.forEach(item => {
          // 后端字段 customsId 映射到前端下拉框绑定字段 customsBrokerCmpIdx，统一转为字符串以匹配 el-option value
          if (item.customsId != null && item.customsId !== '') {
            item.customsBrokerCmpIdx = String(item.customsId)
          }
          // 报关货值币种默认显示第一个
          if (!item.customsValueCurrency) {
            item.customsValueCurrency = firstCurrency
          }
        })
        this.customsDataList = parsedList
        this.customsDataList.forEach((item, idx) => {
          // 清关关税自动计算（保留两位小数）
          this.calculateCustomsTariff(idx)
        })
        this.originalDataList = JSON.parse(JSON.stringify(list))
        this.fillDefaultsFromJob()
        this.restoreBrokerNames()
      } else {
        this.initDefaultRow()
        this.originalDataList = []
      }
    },
    async loadBondList() {
      try {
        const res = await getEffectiveAndWarningBonds()
        if (res && res.ok && res.data) {
          this.bondList = res.data
        } else {
          this.bondList = []
        }
      } catch (e) {
        console.error('加载Bond列表失败:', e)
        this.bondList = []
      }
    },
    async loadCurrencyList() {
      try {
        const res = await getNoPaginationCurrencyList()
        this.currencyList = res.data || []
      } catch (e) {
        console.error('加载币种列表失败:', e)
      }
    },
    async loadCustomsBrokerList() {
      try {
        const res = await getCompanyListByType4Cache({ type: 'customsBroker', active: true })
        this.customsBrokerList = (res && res.data && res.data.list) || []
      } catch (e) {
        console.error('加载清关行列表失败:', e)
        this.customsBrokerList = []
      }
    },
    searchCustomsBroker(query) {
      if (!query) {
        this.loadCustomsBrokerList()
        return
      }
      if (this.customsBrokerSearchTimer) {
        clearTimeout(this.customsBrokerSearchTimer)
      }
      this.customsBrokerSearchTimer = setTimeout(async() => {
        try {
          const res = await getCompanyListByType4Cache({ type: 'customsBroker', active: true, likeName: query })
          this.customsBrokerList = (res && res.data && res.data.list) || []
        } catch (e) {
          console.error('搜索清关行失败:', e)
        }
      }, 300)
    },
    async onCustomsBrokerChange(item) {
      if (item.customsBrokerCmpIdx) {
        const broker = this.customsBrokerList.find(b => String(b.cmpIdx) === String(item.customsBrokerCmpIdx))
        if (broker) {
          item.customsBroker = broker.chineseName || broker.englishName || ''
        }
        // 根据清关行ID获取Bond信息
        try {
          const res = await getBondByCustomsBrokerId(item.customsBrokerCmpIdx)
          if (res && res.ok && res.data && res.data.length > 0) {
            // 获取到Bond信息，取第一条的bondNo赋值
            item.bond = res.data[0].bondNo || ''
            // 同时加载所有有效和到期预警的Bond作为下拉选项
            await this.loadBondList()
          } else {
            item.bond = ''
          }
        } catch (e) {
          console.error('获取Bond信息失败:', e)
          item.bond = ''
        }
      }
    },
    onBondChange(item) {
      // Bond选择变化时的处理
    },
    restoreBrokerNames() {
      this.customsDataList.forEach(item => {
        if (item.customsBrokerCmpIdx) {
          const broker = this.customsBrokerList.find(b => String(b.cmpIdx) === String(item.customsBrokerCmpIdx))
          if (broker) {
            item.customsBroker = broker.chineseName || broker.englishName || item.customsBroker || ''
          }
        }
      })
    },
    fillDefaultsFromJob() {
      const job = this.jobData || {}
      const jobHsCode = job.hsCode || ''
      const jobChineseName = job.cargoChineseName || ''
      const jobEnglishName = job.cargoEnglishName || ''
      if (!jobHsCode && !jobChineseName && !jobEnglishName) return
      this.customsDataList.forEach(item => {
        if (!item.hsCode) item.hsCode = jobHsCode
        if (!item.chineseName) item.chineseName = jobChineseName
        if (!item.englishName) item.englishName = jobEnglishName
      })
    },
    copyConsignToCustoms(index) {
      const item = this.customsDataList[index]
      if (!item) return
      item.customsHsCode = item.hsCode || ''
      item.customsChineseName = item.chineseName || ''
      item.customsEnglishName = item.englishName || ''
      item.customsValue = item.declaredValue || 0
      item.customsValueCurrency = item.currency || 'USD'
      item.customsTariffRate = item.tariffRate || 0
      this.calculateCustomsTariff(index)
      this.$message.success('已复制委托信息到清关信息区域')
    },
    calculateCustomsTariff(index) {
      const item = this.customsDataList[index]
      if (item.customsValue && item.customsTariffRate) {
        item.customsTariff = (item.customsValue * item.customsTariffRate / 100).toFixed(2)
      } else {
        item.customsTariff = 0
      }
    },
    initDefaultRow() {
      const job = this.jobData || {}
      const defaultRow = {
        uuid: '',
        jobUuid: job.uuid || '',
        jobNo: job.jobNo || '',
        lineNum: 1,
        hsCode: job.hsCode || '',
        chineseName: job.cargoChineseName || '',
        englishName: job.cargoEnglishName || '',
        declaredValue: 0,
        currency: 'USD',
        tariffRate: 0,
        estimatedTariff: 0,
        customsHsCode: '',
        customsChineseName: '',
        customsEnglishName: '',
        customsValue: 0,
        customsValueCurrency: 'USD',
        customsTariffRate: 0,
        customsTariff: 0,
        customsBrokerCmpIdx: '',
        customsBroker: '',
        bond: ''
      }
      this.customsDataList = [defaultRow]
    },
    addRow() {
      const newRow = {
        uuid: '',
        jobUuid: this.jobData.uuid || '',
        jobNo: this.jobData.jobNo || '',
        lineNum: this.customsDataList.length + 1,
        hsCode: '',
        chineseName: '',
        englishName: '',
        declaredValue: 0,
        currency: 'USD',
        tariffRate: 0,
        estimatedTariff: 0,
        customsHsCode: '',
        customsChineseName: '',
        customsEnglishName: '',
        customsValue: 0,
        customsValueCurrency: 'USD',
        customsTariffRate: 0,
        customsTariff: 0,
        customsBrokerCmpIdx: '',
        customsBroker: '',
        bond: ''
      }
      this.customsDataList.push(newRow)
    },
    deleteItem(index) {
      if (this.customsDataList.length <= 1) {
        this.$message.warning('至少保留一条品名数据')
        return
      }
      this.customsDataList.splice(index, 1)
      this.customsDataList.forEach((row, idx) => {
        row.lineNum = idx + 1
      })
    },
    calculateEstimatedTariff(index) {
      const item = this.customsDataList[index]
      if (item.declaredValue && item.tariffRate) {
        item.estimatedTariff = (item.declaredValue * item.tariffRate / 100).toFixed(2)
      } else {
        item.estimatedTariff = 0
      }
    },
    // 校验申报货值（仅远程订舱保存时调用）
    validateDeclaredValue() {
      for (const item of this.customsDataList) {
        const val = item.declaredValue
        if (val === null || val === undefined || val === '') {
          this.$message.warning('申报货值不能为空')
          return false
        }
        if (Number(val) <= 0) {
          this.$message.warning('申报货值不能小于等于0')
          return false
        }
      }
      return true
    },
    getSubmitData() {
      return {
        destinationCustomsDataList: this.customsDataList.map(item => {
          const { customsBrokerCmpIdx, ...rest } = item
          return {
            ...rest,
            customsId: customsBrokerCmpIdx || '',
            customsBroker: item.customsBroker || '',
            customsValueCurrency: item.customsValueCurrency || item.currency || 'USD'
          }
        })
      }
    },
    endTabHandler() {
    }
  }
}
</script>

<style scoped>
.customs-data-container {
  overflow-y: auto;
}
.customs-data-row {
  padding: 15px 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-bottom: 15px;
  background: #fff;
}
.row-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.row-title {
  font-weight: bold;
  font-size: 15px;
  color: #303133;
}
.customs-section {
  margin-bottom: 15px;
}
.section-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 400px;
  margin-bottom: 10px;
}
.section-title-row .section-title {
  margin-bottom: 0;
}
/* 缩小复制委托信息按钮 */
.copy-consign-btn {
  padding: 2px 6px !important;
  font-size: 12px !important;
  height: 22px !important;
  line-height: 1 !important;
}
.copy-consign-btn i {
  font-size: 12px !important;
}
.customs-data-container ::v-deep .el-textarea__inner::-webkit-input-placeholder,
.customs-data-container ::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #C0C4CC;
}
.customs-data-container ::v-deep .el-textarea__inner::-moz-placeholder,
.customs-data-container ::v-deep .el-input__inner::-moz-placeholder {
  color: #C0C4CC;
}
.customs-data-container ::v-deep .el-textarea__inner:-ms-input-placeholder,
.customs-data-container ::v-deep .el-input__inner:-ms-input-placeholder {
  color: #C0C4CC;
}
.customs-data-container ::v-deep .el-textarea__inner::placeholder,
.customs-data-container ::v-deep .el-input__inner::placeholder {
  color: #C0C4CC;
}
.customs-data-container ::v-deep .is-disabled .el-textarea__inner::-webkit-input-placeholder,
.customs-data-container ::v-deep .is-disabled .el-input__inner::-webkit-input-placeholder {
  color: #DCDFE6;
}
.customs-data-container ::v-deep .is-disabled .el-textarea__inner::placeholder,
.customs-data-container ::v-deep .is-disabled .el-input__inner::placeholder {
  color: #DCDFE6;
}
.section-title {
  font-weight: bold;
  color: #303133;
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
}
.estimated-tariff-tip {
  margin-left: 10px;
  font-size: 12px;
  color: #E6A23C;
}
.add-row-area {
  text-align: center;
  padding: 10px 0;
  margin-top: 10px;
}
/deep/ .el-form-item {
  margin-bottom: 12px;
}
/deep/ .el-form-item__label {
  font-weight: 500;
  color: #606266;
}
/deep/ .el-form-item.is-disabled .el-input__inner {
  background-color: #F5F7FA;
  color: #909399;
}
/deep/ .el-form-item .el-input__inner {
  max-width: 400px;
}
</style>
